'use strict'

import React from 'react'
import { Button } from 'reactstrap'
import { translate } from 'react-i18next'
import CircularProgress from '@material-ui/core/CircularProgress'
import { createUser, formatError } from './../helpers/firebase'
import { createProfile } from './../fetcher/api'
import { AvForm } from 'availity-reactstrap-validation'
import AvCustomInput from './AvCustomInput'
import AvCustomCheckbox from './AvCustomCheckbox'
import ModalSuccess from './ModalSuccess'

class SignUpForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      success: false,
      error: '',
      pending: false
    }
    this.avForm = React.createRef()
  }

  handleSubmit(values) {
    const { locale, t } = this.props
    this.setState({ pending: true, success: false, error: '' })

    const {
      email,
      firstName,
      lastName,
      nickname,
      password,
      code,
      gdpr,
      privacy,
      marketing
    } = values

    const bodyUser = {
      email,
      password,
      lang: locale,
      name: `${firstName} ${lastName}`
    }

    const bodyProfile = {
      firstName,
      lastName,
      nickname,
      email,
      locale: locale === 'it' ? 'it-it' : 'en-en',
      code,
      gdpr,
      privacy,
      marketing
    }

    createUser(bodyUser)
      .then(() => createProfile(bodyProfile))
      .then((me) => {
        sessionStorage.setItem('logged', '1')
        sessionStorage.setItem('profile', JSON.stringify(me))
        this.setState({ pending: false, success: true, error: '' })
        this.avForm.current.reset()
      })
      .catch(err => {
        console.log(err)
        this.setState({ pending: false, success: false, error: t(formatError(err.code)) })
      })
  }

  render() {
    const { pending, error, success } = this.state
    const { t } = this.props

    return (
      <div className="col-sm-12 col-md-6">
        <h2>{this.props.t('REGISTER')}</h2>
        <AvForm
          autoComplete="off"
          ref={this.avForm}
          onValidSubmit={(event, values) => this.handleSubmit(values)}
        >
          <AvCustomInput
            name="nickname"
            required={true}
            error={t('FORM_FIELD_REQUIRED')}
            label={t('NICKNAME')}
          />
          <div className="row">
            <div className="col-12 col-sm-6">
              <AvCustomInput
                name="firstName"
                required={true}
                error={t('FORM_FIELD_REQUIRED')}
                label={t('NAME')}
              />
            </div>
            <div className="col-12 col-sm-6">
              <AvCustomInput
                name="lastName"
                required={true}
                error={t('FORM_FIELD_REQUIRED')}
                label={t('SURNAME')}
              />
            </div>
          </div>
          <AvCustomInput
            id="signup-email"
            name="email"
            type="email"
            required={true}
            validate={{ email: true }}
            error={t('FORM_VALID_EMAIL')}
            label={t('EMAIL')}
          />
          <AvCustomInput
            id="signup-password"
            name="password"
            type="password"
            required={true}
            error={t('FORM_FIELD_REQUIRED')}
            label={t('PASSWORD')}
          />
          <AvCustomInput
            name="confirmPassword"
            type="password"
            required={true}
            validate={{ match: { value: 'password' } }}
            error={t('FORM_MISMATCH_PASSWORD')}
            label={t('REPEAT_PASSWORD')}
          />
          <AvCustomInput
            id="code"
            name="code"
            required={false}
            label={t('REGISTERT_CODE')}
          />
          <AvCustomCheckbox
            name="gdpr"
            required={true}
            label={t('ACCEPT_GDPR')}
            error={t('FORM_FIELD_REQUIRED')}
          />
          <AvCustomCheckbox
            name="privacy"
            required={true}
            html={t('ACCEPT_PRIVACY_AND_TERMS', { privacy_url: process.env.PRIVACY_URL })}
            error={t('FORM_FIELD_REQUIRED')}
          />
          <AvCustomCheckbox
            name="marketing"
            html={t('ACCEPT_MARKETING')}
            error={t('FORM_FIELD_REQUIRED')}
          />
          {
            pending ?
              <div className="row spinner-container">
                <CircularProgress className="spinner" />
              </div>
              :
              <Button>
                {t('REGISTER_BTN_SUBMIT')}
              </Button>
          }
          {
            error && <p className="form-input-error">{error}</p>
          }
          <ModalSuccess
            open={success}
            message={t('FIREBASE_EMAIL_SENT')}
            toggle={() => this.setState({ success: !success })}
          />
        </AvForm>
      </div>
    )
  }
}

export default translate(['common'])(SignUpForm)


// WEBPACK FOOTER //
// src/components/SignUpForm.js